import { ListCreditTypesResponseSchema, type ListCreditTypesResponse } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomBaseUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useCreditTypesList(
  options?: CustomBaseUseQueryOptions<ListCreditTypesResponse>,
  params?: { search?: string },
) {
  return useQuery(
    queryKeys.creditTypes(params?.search),
    async () => {
      const api = getPrivateApi();
      const getCreditTypesListResponse = await api.listCreditTypes({ nameSearch: params?.search });

      return ListCreditTypesResponseSchema.parse(getCreditTypesListResponse);
    },
    { suspense: true, ...options },
  );
}
